import React from "react";
import Layout from "./src/components/common/index";
// import ShopProvider from "./src/context/shopContext";
import "./src/styles/global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { initCaching } from "./src/utils/serviceWorker";

export const wrapPageElement = ({ element }) => {
  return (
    // <ShopProvider>
    <Layout>{element}</Layout>
    // </ShopProvider>
  );
};

// Initialize caching when the app is ready
export const onClientEntry = () => {
  // Initialize service worker and caching
  if (typeof window !== "undefined") {
    // Wait for the page to load to ensure service worker doesn't
    // impact initial page load performance
    window.addEventListener("load", () => {
      initCaching();
    });
  }
};

export function shouldUpdateScroll({
  routerProps: { location },
  getSavedScrollPosition,
}) {
  const state = location?.state;
  if (state?.disableScrollUpdate) {
    return false;
  }

  const animationDuraion = 0.3;
  const scrollDelay = animationDuraion * 1000;

  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), scrollDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(() => window.scrollTo(...[0, 0]), scrollDelay);
  }

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  return false;
}
